/* ============================================================
   SANTJAKOV — ficha destacada (`pshow`)
   Cambiar de prenda, de color o de vista NO recarga la página: los datos de
   todas las prendas del grupo viajan en el JSON de la sección, igual que el
   sitio estático los tenía en su CATALOG.
   ============================================================ */
(function(){
  const D=document;
  D.querySelectorAll('.pshow[data-pick]').forEach(montar);

  function montar(raiz){
    /* Los datos NO pueden ser requisito para que la interfaz responda. Antes,
       si el JSON venía mal, esta función salía aquí mismo y el desplegable ni
       siquiera abría: un fallo de datos se veía como un botón muerto. Ahora se
       avisa por consola y se sigue montando lo que sí puede funcionar. */
    const caja=raiz.querySelector('.pshow-datos');
    let datos={};
    if(caja){
      try{ datos=JSON.parse(caja.textContent); }
      catch(e){ console.warn('[santjakov] La ficha destacada no pudo leer sus datos:',e); }
    }else{
      console.warn('[santjakov] La ficha destacada no encontró su bloque de datos.');
    }

    const q=s=>raiz.querySelector(s);
    const nombre=q('.pshow-nm-txt'), boton=q('.pshow-nm'), lista=q('.pshow-list');
    const elColor=q('.pshow-color'), elPrecio=q('.pshow-price'), elDesc=q('.pshow-desc');
    const media=q('.pshow-media'), dots=q('.pshow-dots');
    const cajaColores=q('.pshow-colors'), cajaTallas=q('.pshow-sizes');
    const campoId=q('input[name="id"]'), botonAdd=q('.pshow-add');

    let handle=lista?.querySelector('[aria-selected="true"]')?.dataset.handle
              || Object.keys(datos)[0];
    let color=null, talla=null;

    const dinero=c=>'$'+(c/100).toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2});
    const TONOS={'Black':'#1a1a1a','White':'#e8e5df','Beige':'#d6c8b4','Green':'#214036','Light Grey':'#c9c9c7','Dark Grey':'#4a4a4a','Grey':'#4a4a4a'};

    function pintar(){
      const p=datos[handle]; if(!p) return;
      if(nombre) nombre.textContent=p.titulo;
      if(elDesc) elDesc.textContent=p.desc;
      color=p.colores[0]||null; talla=null; vista=0;

      ponerFotos();

      if(cajaColores) cajaColores.innerHTML=p.colores.map((c,i)=>
        `<button type="button" class="pshow-color-op${i===0?' sel':''}" data-color="${c}"
          style="--tono:${(p.tonos&&p.tonos[c])||TONOS[c]||'#999999'}" title="${c}" aria-label="${c}"></button>`).join('');
      if(cajaTallas) cajaTallas.innerHTML=p.tallas.map((t,i)=>
        `<button type="button" style="--i:${i}" data-size="${t}">${t}</button>`).join('');

      refrescar();
    }

    /* Las vistas son las fotos del COLOR elegido (el texto alternativo de cada
       foto lleva el nombre del color, igual que en la ficha de producto). Antes
       se mostraban las cuatro primeras de la prenda, de cualquier color, y al
       cambiar de color solo se cambiaba la primera. */
    function ponerFotos(){
      const p=datos[handle]; if(!p||!media) return;
      const delColor=(p.fotosColor&&p.fotosColor[color])||[];
      const fotos=delColor.length?delColor:(p.fotos.length?p.fotos:['']);
      [...media.querySelectorAll('.pshow-img')].forEach(el=>el.remove());
      fotos.forEach((f,i)=>{
        const img=D.createElement('img');
        img.className='pshow-img'+(i===0?' is-on':'');
        /* a 1400 px solo en pantallas que lo necesiten: en teléfono baja la de 700 o 1000 */
        if(/([?&])width=\d+/.test(f)){
          img.srcset=[700,1000,1400].map(w=>f.replace(/([?&])width=\d+/,'$1width='+w)+' '+w+'w').join(', ');
          img.sizes='(max-width:900px) 100vw, 40vw';
        }
        img.src=f; img.alt=p.titulo;
        if(i) {img.loading='lazy'; img.decoding='async';}
        media.insertBefore(img,dots||null);
      });
      if(dots){
        dots.innerHTML=fotos.map((_,i)=>
          `<button class="${i===0?'is-on':''}" data-i="${i}" aria-label="View ${i+1}"></button>`).join('');
        dots.hidden=fotos.length<2;
      }
      vista=0;
    }

    /* ─── Vistas: los puntos de abajo y las flechas hacen lo mismo ─── */
    let vista=0;
    function irA(i){
      const fotos=[...raiz.querySelectorAll('.pshow-img')];
      if(!fotos.length) return;
      vista=(i+fotos.length)%fotos.length;
      fotos.forEach((el,n)=>el.classList.toggle('is-on',n===vista));
      dots&&dots.querySelectorAll('button').forEach((el,n)=>el.classList.toggle('is-on',n===vista));
      pintarPuntos();
    }

    /* ─── Puntos de detalle sobre la primera foto ───
       Solo en la vista 0, que es la foto de la prenda puesta: las coordenadas
       del metacampo están medidas sobre ESA foto. Al pasar a otra vista se
       quitan, porque encima de un close-up no señalarían nada. */
    const cajaPts=q('.pshow-pts');
    const esc=t=>String(t).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    /* solo el nombre del archivo: la misma foto llega por dos dominios (la CDN
       de Shopify y la de la tienda) y con anchos distintos */
    const archivo=u=>{ try{ return new URL(u,location.href).pathname.split('/').pop(); }catch(e){ return u; } };
    let puntosAct=[];
    function pintarPuntos(){
      if(!cajaPts) return;
      const p=datos[handle];
      puntosAct=(vista===0&&p&&p.puntos&&(p.puntos[color]||p.puntos['*']))||[];
      cajaPts.innerHTML=puntosAct.map((pt,i)=>{
        const lado=pt.x>55?' izq':'', alto=pt.y>70?' abajo':(pt.y<28?' arriba':'');
        const pos=`style="--x:${+pt.x}%;--y:${+pt.y}%"`;
        return `<button type="button" class="pshow-pt" ${pos} data-pt="${i}" aria-label="${esc(pt.t)}" data-cursor="View"></button>
          <figure class="pshow-pop${lado}${alto}" ${pos}><img src="${esc(pt.img)}" alt="" loading="lazy" decoding="async"></figure>`;
      }).join('');
    }

    /* Un clic en el punto lleva a la foto COMPLETA de ese detalle, en la misma
       galería. Si la foto ya está entre las vistas se salta a ella; si no (los
       puños no son foto de producto) se añade como una vista más, con su punto
       abajo, y se quita al cambiar de color o de prenda. */
    function verDetalle(pt){
      if(!media||!pt) return;
      const fotos=[...raiz.querySelectorAll('.pshow-img')];
      let i=fotos.findIndex(el=>archivo(el.src)===archivo(pt.img));
      if(i<0){
        const img=D.createElement('img');
        img.className='pshow-img pshow-img--det';
        img.src=String(pt.img).replace(/([?&])width=\d+/,'$1width=1400');
        img.alt=pt.t||'';
        media.insertBefore(img,dots||cajaPts);
        i=fotos.length;
        if(dots){
          dots.insertAdjacentHTML('beforeend',
            `<button class="pshow-dot--det" data-i="${i}" aria-label="View ${i+1}"></button>`);
          dots.hidden=false;
        }
      }
      irA(i);
    }
    function quitarDetalles(){
      raiz.querySelectorAll('.pshow-img--det,.pshow-dot--det').forEach(el=>el.remove());
      irA(0);
    }

    /* Una talla solo existe si hay variante de ESE color con ESA talla. */
    function refrescar(){
      const p=datos[handle]; if(!p) return;
      if(elColor) elColor.textContent=color||'';
      raiz.querySelectorAll('.pshow-sizes button').forEach(b=>{
        const v=p.variantes.find(x=>x.color===color&&x.talla===b.dataset.size);
        const hay=!!v&&v.hay;
        b.disabled=!hay; b.classList.toggle('agotada',!hay);
        if(!hay) b.classList.remove('sel');
      });
      const v=p.variantes.find(x=>x.color===color&&(talla?x.talla===talla:true));
      pintarPuntos();
      if(v){
        if(elPrecio) elPrecio.textContent=dinero(v.precio);
        if(talla&&campoId) campoId.value=v.id;
      }
    }

    /* Un solo oyente por sección: los botones se repintan al cambiar de prenda,
       así que engancharlos uno a uno se perdería en el primer cambio. */
    raiz.addEventListener('click',ev=>{
      const t=ev.target;
      if(t.closest('.pshow-nm')){
        const abierto=lista&&lista.hidden;
        if(lista) lista.hidden=!abierto;
        boton&&boton.setAttribute('aria-expanded',String(abierto));
        return;
      }
      const op=t.closest('.pshow-list li');
      if(op){
        handle=op.dataset.handle;
        lista.querySelectorAll('li').forEach(li=>li.setAttribute('aria-selected',String(li===op)));
        lista.hidden=true; boton&&boton.setAttribute('aria-expanded','false');
        pintar(); return;
      }
      const c=t.closest('.pshow-color-op');
      if(c){
        color=c.dataset.color; talla=null;
        cajaColores.querySelectorAll('.pshow-color-op').forEach(o=>o.classList.toggle('sel',o===c));
        ponerFotos();
        refrescar(); return;
      }
      const s=t.closest('.pshow-sizes button');
      if(s&&!s.disabled){
        talla=s.dataset.size;
        cajaTallas.querySelectorAll('button').forEach(o=>o.classList.toggle('sel',o===s));
        if(botonAdd) botonAdd.classList.remove('needs');
        if(cajaTallas){
          cajaTallas.classList.remove('falta','flash');
          const rot=cajaTallas.previousElementSibling; rot&&rot.classList.remove('falta');
          const msg=cajaTallas.parentNode.querySelector('.falta-msg'); msg&&msg.remove();
        }
        refrescar(); return;
      }
      const d=t.closest('.pshow-dots button');
      if(d){ irA(+d.dataset.i); return; }
      const fl=t.closest('.pshow-arrow');
      if(fl){ irA(vista+(+fl.dataset.dir)); return; }
      const pt=t.closest('.pshow-pt');
      if(pt){ verDetalle(puntosAct[+pt.dataset.pt]); }
    });

    const formulario=raiz.querySelector('form');
    formulario&&formulario.addEventListener('submit',ev=>{
      if(!talla){
        ev.preventDefault();
        if(botonAdd) botonAdd.classList.add('needs');
      /* LO QUE FALTA, EN ROJO (web-pitfalls #22): las tallas y su rótulo se
         marcan, un texto dice qué falta y la página lleva hasta ahí. El rojo se
         queda hasta que se elige talla; no es un parpadeo. */
      if(cajaTallas){
        cajaTallas.classList.add('falta');
        const rot=cajaTallas.previousElementSibling; if(rot&&rot.classList.contains('lbl')) rot.classList.add('falta');
        let msg=cajaTallas.parentNode.querySelector('.falta-msg');
        if(!msg){ msg=document.createElement('p'); msg.className='falta-msg'; msg.setAttribute('role','alert'); cajaTallas.insertAdjacentElement('afterend',msg); }
        msg.textContent=(botonAdd&&botonAdd.dataset.falta)||'Select a size';
        const r=cajaTallas.getBoundingClientRect();
        if(r.top<90||r.bottom>innerHeight-20) cajaTallas.scrollIntoView({block:'center',behavior:'smooth'});
      }
      }
    });

    const p=datos[handle];
    if(p){ color=p.colores[0]||null; ponerFotos(); refrescar(); }
  }

  /* ─────── LOS DOS LADOS, A LA MISMA DISTANCIA DE LA PRENDA ───────
     Las dos columnas laterales miden lo mismo, así que el hueco que cada
     bloque deja hasta la foto es «ancho de columna − ancho del bloque». El de
     texto mide 410 px porque la descripción está topada; el de compra, 154.
     De ahí que uno se vea pegado a la prenda y el otro lejos: 122 px contra
     213.

     Se igualan dándole a la caja de la derecha el mismo ancho que la de la
     izquierda —anclada a su borde exterior, con el contenido pegado al lado de
     la foto—. En CSS no se puede: haría falta leer el ancho del bloque de
     texto, que cambia con cada prenda y con el tamaño de la ventana. Son dos
     medidas y una asignación.

     Se recalcula al redimensionar y cuando cambia la prenda elegida, que es
     cuando el texto cambia de largo. */
  function emparejarLados(){
    D.querySelectorAll('.pshow').forEach(sec=>{
      const info=sec.querySelector('.pshow-info'), buy=sec.querySelector('.pshow-buy');
      if(!info||!buy) return;
      if(getComputedStyle(sec).gridTemplateColumns.split(' ').length<3){
        buy.style.width=''; return;          /* apilado en móvil: sin lados */
      }
      buy.style.width=info.getBoundingClientRect().width+'px';
    });
  }
  window.__emparejarLados=emparejarLados;
  addEventListener('resize',emparejarLados);
  addEventListener('load',emparejarLados);
  emparejarLados();
})();
